import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { history } from "@state";

// EVENT PAGE TODO: no longer needed

export const BackButton = observer(function BackButton(props: {
	addClassName?: string;
	changeClassName?: string;
	iconClassName?: string;
}) {
	const { t } = useTranslation();

	const location = useLocation();

	const urlParams = new URLSearchParams(location.search);

	let msgKey = "COMMON.BACK";

	if (urlParams.has("submitted")) {
		msgKey = "FOOTER.MY_BETS";
	}

	return (
		<button
			className={classNames(props.addClassName, props.changeClassName, {
				"btn btn--sml btn--ghost btn--icon u-padd--x--reset":
					!props.changeClassName,
			})}
			onClick={history.goBack}
		>
			<i
				className={classNames(
					"u-icon u-icon--arrow-left",
					props.iconClassName,
					{
						"u-icon--tny": !props.iconClassName,
					}
				)}
			/>
			{msgKey && <span>{t(msgKey)}</span>}
		</button>
	);
});
